<script setup lang="ts">
    const appStore = useAppStore();
    const bikefinderStore = useBikefinderStore();
    const cartStore = useCartStore();
    const route = useRoute();
    const notificationStore = useNotificationStore();
    const { locale, isUS } = useLocales();
    const { queryParams } = usePreview();

    await Promise.all([
        callOnce('website', () => appStore.fetchWebsiteConfig(locale.value, queryParams.value)),
        callOnce('notifications', () => notificationStore.fetchNotifications()),
        callOnce('bikefinderlinks', () => bikefinderStore.fetchBikefinderlinks(locale.value)),
    ]);

    let { closedNotificationIds, notifications } = storeToRefs(notificationStore);

    const notificationsWithVisibility = computed(() =>
        notifications.value.map((notification) => {
            const isVisible = computed(
                () =>
                    !(
                        (notification.lang !== 'en_US' && isUS.value) || // US only filtering - deprecated should be
                        notification.data.path_excludes.some(
                            (pathExclude) =>
                                // Path exact match
                                pathExclude === route.path ||
                                // Path with wildcard match
                                (pathExclude.endsWith('*') && route.path.startsWith(pathExclude.slice(0, -1))),
                        ) || // route filter
                        // notification by ID excludes
                        closedNotificationIds.value.has(notification.id)
                    ),
            );
            return {
                ...notification,
                isVisible,
            };
        }),
    );
    const notificationIdToShow = computed(() => notificationsWithVisibility.value.find((notification) => notification.isVisible.value)?.id);

    useFriendBuyUS();

    onMounted(() => {
        cartStore.fetch();
    });
</script>

<template>
    <div class="absolute left-0 top-0 z-xl flex">
        <a
            class="relative inline-flex h-0 items-center justify-center overflow-hidden rounded-md bg-woom-red px-4 text-base font-bold text-woom-white transition-all focus:h-12"
            href="#main-content">
            <span>{{ $t('cta.skipLink') }}</span>
        </a>
    </div>
    <client-only>
        <lazy-org-drawer-group />
        <!-- TODO: can we have one modal that rules them all here as well? -->
        <lazy-mol-video-modal />
        <lazy-org-global-dialog />
        <lazy-mol-account-dialog />
    </client-only>
    <template
        v-for="notification in notificationsWithVisibility"
        :key="notification.id">
        <lazy-mol-notification
            v-show="notificationIdToShow === notification.id"
            :data-show="notificationIdToShow === notification.id"
            :notification="notification" />
    </template>
    <org-header />

    <main
        id="main-content"
        class="min-h-screen-mobile lg:min-h-screen-desktop">
        <nuxt-page />
    </main>
    <lazy-mol-footer />
    <mol-toast-container />
</template>
